import React from "react";
import Card from "../Card/Card";
import { useDashboardData } from "../../Data/Data";
import { getCurrencySymbol } from "../../helper/formatCurrency";
import { useRestaurantConfig } from "../../utils/restaurantConfig";

const Cards = () => {
  const cardsData = useDashboardData() || [];
    const { locale } = useRestaurantConfig();
    const currencySymbol = getCurrencySymbol(locale);

  return (
    <div>
      {/* Section Title */}
      <div className="mb-6">
        <h2 className="font-display font-semibold text-xl text-gray-900 mb-1">
          Quick Stats
        </h2>
        <p className="text-gray-600 text-sm">
          Overview of your restaurant's performance
        </p>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cardsData.length > 0 ? (
          cardsData.map((card, id) => (
            <Card
              key={id}
              title={card.title}
              icon={card.icon}
              color={card.color}
              gradient={card.gradient}
              shadowColor={card.shadowColor}
              series={card.series}
              link={card.link}
              currencySymbol={currencySymbol}
            />
          ))
        ) : (
          <div className="col-span-full">
            <div className="flex flex-col items-center justify-center py-16">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-300 mb-4"></div>
              <p className="text-gray-500 text-sm">Loading dashboard data...</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cards;
